<template>
  <div
    class="tender-info-panel"
    :class="{'is-open': currentBlock.component, 'has-scroll': hasScroll}"
    :data-qa="dataQa"
    :style="`--panel-width: ${panelWidth}px; --right-block-compact: 44px;`">
    <slot/>
    <div
      v-show="currentBlock && currentBlock.component"
      id="seperator"/>
    <div
      class="tender-info-panel__right"
      :class="{'is-footer': isHasFooter}">
      <div
        class="tender-info-panel__right-menu">
        <div
          v-if="currentBlock.component"
          class="tender-info-panel__right-title">
          <HistoryDialog
            class="ml-1"
            :current-tab="tennderInfoTab"
            data-qa="history-dialog"
            :disabled="!currentBlock || currentBlock.component === 'InfoBar'"
            :item-id.sync="historyDialogProps.itemId"
            :open.sync="historyDialogProps.open"
            :tabs="$_tabs"
            :tender="tender"
            @loadPage="$_getInnerChat(subscribleEntity)"
            @update-items="updateItems"
            @update:currentTab="changeItem"/>
          <span
            class="tender-info-panel__right-title-label"
            data-qa="history-dialog-name">{{ currentBlock.name }}</span>
        </div>
        <div
          class="my-auto">
          <TenderInfoMenu
            ref="menu"
            :can-change-winners="can_change_winners"
            :change-winner-mode="change_winner_mode"
            data-qa="tender-info-menu"
            :disabled="loading || !tender"
            :is-can-edit="can_edit"
            :need-load-agreements.sync="needLoadAgreements"
            :tender="tender"
            @changedWinnersFinishedTender="$root.$emit('changedWinnersFinishedTender')"
            @needOpenDocuments="$emit('needOpenDocuments')"
            @update:changeWinnerMode="val => $emit('update:change_winner_mode', val)"/>
        </div>
      </div>
      <div
        class="tender-info-panel__right-content">
        <div
          v-if="currentBlock.component"
          class="tender-info-panel__right-component"
          :data-qa="currentBlock.component">
          <component
            :is="currentBlock.component"
            v-bind="componentOptions"
            v-on="componentOn">
            <ListOfAcceptors
              v-if="currentBlock.component === 'InfoBar'"
              :acceptors="loadAgreements ? [] : $_agreements || []"
              class="mt-3 ml-3"
              data-qa="list-of-acceptors"
              :item="tender"
              :stages="$_stageAgreements"
              :use-avatar="false"
              :with_loading="loadAgreements || loading"/>
          </component>
        </div>
        <div
          class="tender-info-panel__right-btns">
          <sBadge
            v-for="listItem in listItems"
            :key="listItem.component"
            color="red"
            :content="listItem.count"
            :data-qa="`badge-${listItem.tabIcon}`"
            :dot="listItem.badge.dot"
            :inner-styles="listItem.badge.dot ? '' : 'padding: 2px; height: 14px; min-width: 14px;'"
            :offset-x="listItem.badge.offsetX"
            :offset-y="listItem.badge.offsetY"
            overlap
            :value="!!listItem.count">
            <TooltipedBtn
              class="tender-info-panel__right-item"
              :color="currentBlock.component === listItem.component ? 'var(--v-secondary__green_not_active-base)' : 'var(--text-color)'"
              :data-qa="`btn-${listItem.tabIcon}`"
              :disabled="loading"
              :icon="listItem.tabIcon"
              icon_size="22px"
              :text="listItem.name"
              @click="changeItem(listItem.index)"/>
          </sBadge>
        </div>
      </div>
      <slot name="footer"/>
    </div>
  </div>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import HistoryDialog from 'components/common/dialogs/HistoryDialog.vue'

import TenderInfoMenu from 'components/tenders/tender page/TenderInfoMenu.vue'
import InfoBar from 'components/tenders/tender page/InfoBar.vue'
import HistoryInnerChat from 'components/common/blocks/inner-chat/HistoryInnerChat.vue'
import CommentHistory from 'components/common/blocks/comments/CommentHistory.vue'
import QuestionsHistory from 'components/common/blocks/questions/QuestionsHistory.vue'
import EventHistory from 'components/common/blocks/history/EventHistory.vue'
import AgreementsHistory from 'components/agreement/AgreementsHistory.vue'
import ListOfAcceptors from 'components/agreement/ListOfAcceptors.vue'
import TenderAutomationEvents from 'components/tenders/tender page/TenderAutomationEvents.vue'

import tenderInfoPanelMixin from 'mixins/tenderInfoPanelMixin.js'
import displaySize from 'mixins/display-size'

export default {
  name: 'TenderInfoPanel',
  mixins: [ tenderInfoPanelMixin, displaySize ],
  data() {
    return {
      panelWidth: 356,
      currentBlock: {},
      needLoadAgreements: true,
      loadAgreements: false,
    }
  },
  methods: {
    updateItems(val) {
      this.$set(this, val.prop, val.val)
    },
    async dragElement() {
      const element = document.getElementById('seperator')
      if (element) {
        element.onmousedown = this.dragMouseDown
      }
    },
    dragMouseDown() {
      document.onmousemove = this.onMouseMove
      document.onmouseup = () => { document.onmousemove = document.onmouseup = null }
    },
    checkPanelWidth(panelWidth) {
      if (panelWidth + 100 > window.innerWidth) {
        return window.innerWidth - 100
      }
      return panelWidth
    },
    onMouseMove(e) {
      const distanceFromRight = window.innerWidth - e.clientX
      if (distanceFromRight <= 356) {
        return
      }
      this.$_savePropToDBStorage('tenderNavbarWidth', distanceFromRight)
      this.panelWidth = this.checkPanelWidth(distanceFromRight)
    },
    async changeItem(value, init) {
      this.tennderInfoTab = value
      const componentProps = this.listItems.find(i => i.index === value) ?? {}
      this.currentBlock = !init && this.currentBlock?.component === componentProps?.component ? {} : componentProps
      if (!this.currentBlock?.component) {
        this.historyDialogProps.open = false
      }
      this.$emit('update:mini', !this.currentBlock?.component)
      await this.$_savePropToDBStorage('tenderNavbar', JSON.stringify(this.currentBlock))

      await this.dragElement()
      if (!this.tender?.tenderId) {
        return
      }
      this.getPanelDate()
    },
    async getPanelDate() {
      this.loading = true

      /** всегда запрашиваем что б отобразить индикатор новых сообщений */
      await this.$_getInnerChat(this.subscribleEntity, true)
      await this.$_getTenderQuestions()
      /** всегда запрашиваем что б отобразить индикатор новых сообщений */

      switch (this.currentBlock?.component) {
      /*case 'InfoBar':
        await this.updateAgreements() // Вызывает цикл
        break*/
      case 'CommentHistory':
        if (!this.comments.length) {
          await this.$_getTenderComment()
        }
        break
      case 'EventHistory':
        if (!this.history.length) {
          await this.$_getTenderHistory()
        }
        break
      case 'AgreementsHistory':
        if (!this.agreements.length) {
          await this.$_getAgreementsHistory()
        }
        break
      default:
        break
      }
      this.loading = false
    },
    async initTenderInfoPanelProps() {
      if (!this.tender?.tenderId || this.small) {
        return
      }
      this.needLoadAgreements = false
      this.getPanelDate()
      this.loadAgreements = true
      try {
        await this.$store.dispatch('agreeLatest', [Number(this.tender.tenderId)]).then(res => {
          this.$_setAgreementValues(res || [])
          if (!res?.length ) {
            this.$emit('changeAcceptors', null)
          }
          return res
        })
          .finally(() => {
            this.loadAgreements = false
          })
      } catch (er) {
        this.$log_error(er)
      }
      this.loading = false
    },
    async updateAgreements() {
      this.needLoadAgreements = true
      await this.initTenderInfoPanelProps()
    }
  },
  computed: {
    isHasFooter() {
      return this.$slots.footer
    },
    listItems() {
      const result =  [...[
        {
          tabIcon: 'info',
          name: this.$t('Tenders.AboutTender'),
          component: 'InfoBar',
          badge: {},
          index: -1
        },
      ],
      ...this.$_tabs.map((i, index) => { return {...i, index: index } })
      ]

      if (this.$acl.check('isGoodMode')) {
        result.push({
          tabIcon: 'circle-start',
          name: this.$t('Menu.AutomationEvents'),
          component: 'TenderAutomationEvents',
          badge: {},
        })
      }

      return result
    },
    componentOptions() {
      switch (this.currentBlock?.component) {
      case 'InfoBar':
        return {
          ref: 'info',
          full: true,
          tender: this.tender
        }
      case 'HistoryInnerChat':
        return {
          item: this.tender,
          loading: this.loading,
          value: this.innerChat,
          style: 'margin: 0 5px;'
        }
      case 'CommentHistory':
        return {
          items: this.comments,
          loading: this.loading,
          style: 'padding-top: 10px; margin: 0 10px;'
        }
      case 'QuestionsHistory':
        return {
          items: this.questions,
          loading: this.loading,
          style: 'padding-top: 10px; margin: 0 10px;'
        }
      case 'EventHistory': {
        return {
          items: this.history,
          spr: this.sprHistory,
          loading: this.loading,
          style: 'margin: 0 10px;'
        }
      }
      case 'AgreementsHistory': {
        return {
          items: this.agreements,
          loading: this.loading,
          style: 'padding-top: 10px; margin: 0 10px;'
        }
      }
      case 'TenderAutomationEvents': {
        return {
          tenderId: this.tender.tenderId,
          loading: this.loading,
          style: 'margin: 0 10px;'
        }
      }
      default:
        return {}
      }
    },
    componentOn() {
      const that = this
      switch (this.currentBlock?.component) {
      case 'HistoryInnerChat':
        return {
          'loadPage': () => {
            that.$_getInnerChat(that.subscribleEntity)
          }
        }
      case 'CommentHistory':
        return {
          openChat: val => { this.historyDialogProps.itemId = val; this.historyDialogProps.open = true }
        }
      case 'QuestionsHistory':
        return {
          openChat: val => { this.historyDialogProps.itemId = val; this.historyDialogProps.open = true }
        }
      default:
        return {}
      }
    },
  },
  components: {
    InfoBar,
    EventHistory,
    TooltipedBtn,
    HistoryDialog,
    TenderInfoMenu,
    CommentHistory,
    ListOfAcceptors,
    HistoryInnerChat,
    QuestionsHistory,
    AgreementsHistory,
    TenderAutomationEvents,
  },
  watch: {
    tender: {
      immediate: true,
      deep: true,
      async handler(newValue) {
        if (newValue && newValue.tenderId && this.needLoadAgreements) {
          await this.initTenderInfoPanelProps()
        }
      }
    },
  },
  created() {
    //this.$emit('update:mini', true)
    this.$root.$on('tenderUpdateAgreements', this.updateAgreements)
  },
  async beforeDestroy() {
    this.$root.$off('tenderUpdateAgreements', this.updateAgreements)
  },
  mounted() {
    this.loading = true
    if (!this.breakpoint.smAndDown) {
      this.$_getPropFromDBStorage('tenderNavbarWidth', 356)
        .then(async(result) => {
          this.panelWidth = this.checkPanelWidth(+result)
        })
      this.$_getPropFromDBStorage('tenderNavbar', {})
        .then(async (result) => {
          try {
            const newIndex = JSON.parse(result)?.index
            if (result && newIndex !== undefined) {
              await this.changeItem(newIndex, true)
            } else {
              this.currentBlock = {}
              this.$emit('update:mini', true)
            }
          } catch (_) {
            /* */
          }
        })
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    change_winner_mode: {
      type: Boolean
    },
    can_change_winners: {
      type: Boolean
    },
    can_edit: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'TENDER'
    },
    dataQa: {
      type: String,
      default: 'tag-hash'
    },
    small: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
$class: '.tender-info-panel';

#seperator {
  transition: all .2s cubic-bezier(.785,.135,.15,.86) .1s;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  opacity: .2;
  user-select: none;
  border-right: 2px solid var(--v-main__light_green-base);
  border-left: 2px solid var(--v-main__light_green-base);
  background: var(--main__green_locked);
  &:focus,
  &:hover {
    opacity: 1;
    background-color: var(--main__green_locked);
  }
}

#{$class} {
  display: grid;
  grid-template-columns: 1fr 42px;
  height: 100%;
  transition: grid-template-columns 0.3s ease-in-out;
  &>*:first-child>* {
    padding-right: 5px;
    min-width: calc(100% - var(--right-block-compact));
    max-width: calc(100vw - 55px);
    transition: min-width 0.3s ease-in-out;
  }
  &__content {
    background-color: var(--v-main__light_green-base) !important;
  }
  &__right {
    z-index: 10;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-template-rows: var(--right-block-compact) 1fr;
    background-color: var(--v-main__light_green-base) !important;
    width: var(--right-block-compact);
    transition: width 0.3s ease-in-out;
    &.is-footer {
      grid-template-rows: var(--right-block-compact) 1fr 60px;
    }
    &-content {
      margin: 0 0 auto 0;
      height: 100%;
    }
    &-title {
      display: grid;
      grid-template-columns: 40px auto;
      &-label {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      }
    }
    &-menu {
      border-bottom: 1px solid var(--main__green_locked);
      height: 100%;
    }
    &-item {
      cursor: pointer;
      transition: 0.25s all;
    }
    &-menu,
    &-content {
      display: grid;
      grid-template-columns: var(--right-block-compact);
      width: 100%;
    }
    &-btns {
      padding-top: 10px;
      gap: 10px;
      display: grid;
      align-items: center;
      justify-items: center;
      grid-template-rows: repeat(auto-fill, 41px);
      height: 100%;
      border-left: 1px solid transparent;
    }
  }
}
#{$class}.is-open {
  grid-template-columns: calc(100% - 5px - var(--panel-width)) 5px var(--panel-width);
  transition: grid-template-columns 0.3s ease-in-out;
  &.has-scroll {
    grid-template-columns: calc(100% - 13px - var(--panel-width)) 5px var(--panel-width);
  }
  &>*:first-child>* {
    min-width: calc(100% - var(--panel-width));
    transition: min-width 0.3s ease-in-out;
  }
  #{$class}__right {
    width: var(--panel-width);
    transition: width 0.3s ease-in-out;
    &-menu,
    &-content {
      grid-template-columns: minmax(50px, 1fr) var(--right-block-compact);
      transition: grid-template-columns 0.3s ease-in-out;
    }
    &-btns {
      border-left: 1px solid var(--main__green_locked);
    }
    &-component {
      max-height: calc(100vh - var(--right-block-compact));
    }
  }
}
</style>
